import {Question} from "../../Shared/Model/GameData";

export type MemoCardState = "reversed" | "visible" | "disabled"


export default class MemoCard {
    id : number
    question : Question
    state : MemoCardState

    constructor(id: number, question: Question) {
        this.id = id;
        this.question = question;
        this.state = "reversed"
    }
}